// extracted by mini-css-extract-plugin
export default {"rotate":"RotationDropdown-rotate-d8f44f103fd71376e21c06648d9415c3"};